import { combineReducers } from 'redux'

const byId = (state = {}, action) => {
  switch (action.type) {
    // TODO which API call should populate?
    case "RECEIVE_FAVE_PLACES":// switch to action.places?
    case "LOGIN_SUCCESS":
    case "USER_SUCCESS":
      return {
        ...state,
        ...action.user.places.reduce((obj, place) => {
          obj[place.token_id] = place
          return obj
        }, {})
      }
    case 'FAVE_PLACE_DELETED':
      const newState = state
      delete newState[action.id]
      return newState

    case 'UPDATE_FAVE_PLACE_SUCCESS':
    case 'ADD_FAVE_PLACE_SUCCESS':
      const {place} = action
      return {
        ...state,
        [place.token_id]: place
      }

    case 'LOGOUT_SUCCESS':
      return {}

    default:
      // const { id } = action
      // if (id) {
      //   return {
      //     ...state,
      //     [id]: places(state[id], action)
      //   }
      // }
      return state
  }
}

const visibleIds = (state = [], action) => {
  switch (action.type) {
    case "RECEIVE_FAVE_PLACES":
    case "LOGIN_SUCCESS":
    case "USER_SUCCESS":
      return action.user.places.map(place => place.token_id)

    case "FAVE_PLACE_DELETED":
      return state.filter(placeId => placeId !== action.id)

    case 'LOGOUT_SUCCESS':
      return []

    default:
      return state
  }
}


const sortBy = (state = null, action) => {
  switch (action.type) {
    case "SORT_FAVE_PLACES":
      return action.payload || null
    default:
      return state
  }
}


const favoritePlaces = combineReducers({
  byId,
  visibleIds,
  sortBy
})

export default favoritePlaces

// SELECTORS
// redux shopping cart example: https://codesandbox.io/s/github/reactjs/redux/tree/master/examples/shopping-cart
export const getFavoritePlace = (state, id) =>
  // state.account.favoritePlaces.find(place=>place.token_id==id)
  state.byId[id] || {token_id: '', name:'Anywhere', street: 'Includes all locations'}

export const getVisibleFavoritePlaces = state =>
  state.visibleIds.map(id => getFavoritePlace(state, id))



// WEBPACK FOOTER //
// ./src/models/places.js